<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Mechanical Connections</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (handArrangementSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Arrangement:</label>
            <select class="halfWidthInputField" #handArrangementInput
              [class.invalidConfigurationSelection]="isInvalidSelection(handArrangementSelection.Name)"
              (change)="selectionChanged(handArrangementSelection, handArrangementInput.value)"
              [value]="handArrangementSelection.Value.toString()">
              @for (allowable of handArrangementSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="handArrangementSelection.Value && handArrangementSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (paintOptionsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Paint Options:</label>
            <select class="halfWidthInputField" #paintOptionsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
              (change)="selectionChanged(paintOptionsSelection, paintOptionsInput.value)"
              [value]="paintOptionsSelection.Value.toString()">
              @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (returnAirOptionsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Return Air:</label>
            <select class="halfWidthInputField" #returnAirOptionsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(returnAirOptionsSelection.Name)"
              (change)="selectionChanged(returnAirOptionsSelection, returnAirOptionsInput.value)"
              [value]="returnAirOptionsSelection.Value.toString()">
              @for (allowable of returnAirOptionsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="returnAirOptionsSelection.Value && returnAirOptionsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (primaryAirInletSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Primary Air Inlet:</label>
            <select class="halfWidthInputField" #primaryAirInletInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryAirInletSelection.Name)"
              (change)="selectionChanged(primaryAirInletSelection, primaryAirInletInput.value)"
              [value]="primaryAirInletSelection.Value.toString()">
              @for (allowable of primaryAirInletSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryAirInletSelection.Value && primaryAirInletSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (supplyAirOptionsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Supply Air:</label>
            <select class="halfWidthInputField" #supplyAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(supplyAirOptionsSelection.Name)"
              (change)="selectionChanged(supplyAirOptionsSelection, supplyAirInput.value)"
              [value]="supplyAirOptionsSelection.Value.toString()">
              @for (allowable of supplyAirOptionsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="supplyAirOptionsSelection.Value && supplyAirOptionsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (primaryAirLocationSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Primary Air Location:</label>
            <select class="halfWidthInputField" #primaryAirLocationInput
              [class.invalidConfigurationSelection]="isInvalidSelection(primaryAirLocationSelection.Name)"
              (change)="selectionChanged(primaryAirLocationSelection, primaryAirLocationInput.value)"
              [value]="primaryAirLocationSelection.Value.toString()">
              @for (allowable of primaryAirLocationSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="primaryAirLocationSelection.Value && primaryAirLocationSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
          <img class="handArrangementImage"
            [src]="handArrangementImagePath()" alt="UnitImage"/>
        }
      </div>
      <div class="configurationWarningRow">
        <label class="fullWidth">Note: Damper actuator required. An SFR must be requested if the actuators will be shipped by the customer to the factory for installation.</label>
      </div>
    </div>
  }
</div>
